const en = {
  // Payment (financial) status of an order
  financialPending: "Payment pending",
  financialAwaitingAction: "Awaiting customer",
  financialAuthorized: "Authorized",
  financialPaid: "Paid",
  financialPartiallyRefunded: "Partially refunded",
  financialRefunded: "Refunded",
  financialFailed: "Payment failed",
  financialCancelled: "Payment cancelled",
  financialDisputed: "Disputed",
  // Fulfillment status of an order
  fulfillmentUnfulfilled: "Unfulfilled",
  fulfillmentPartiallyFulfilled: "Partially fulfilled",
  fulfillmentFulfilled: "Fulfilled",
  fulfillmentNotRequired: "No shipping",
  // Order status
  orderOpen: "Open",
  orderCompleted: "Completed",
  orderCancelled: "Cancelled",
  // Return request status
  returnRequested: "Requested",
  returnApproved: "Approved",
  returnRejected: "Rejected",
  returnReceived: "Received",
  returnRefunded: "Refunded",
  returnClosed: "Closed",
  // Payment record status
  paymentPending: "Pending",
  paymentAwaitingAction: "Awaiting action",
  paymentAuthorized: "Authorized",
  paymentCaptured: "Captured",
  paymentFailed: "Failed",
  paymentCancelled: "Cancelled",
  paymentPartiallyRefunded: "Partially refunded",
  paymentRefunded: "Refunded",
  paymentDisputed: "Disputed",
  paymentChargeback: "Chargeback",
  // Shipment status
  shipmentShipped: "Shipped",
  shipmentDelivered: "Delivered",
  shipmentCancelled: "Cancelled",
  // Refund status
  refundSucceeded: "Refunded",
  refundPending: "Pending at provider",
  refundFailed: "Failed",

  // Flash notices
  noticePaid: "Payment recorded as received. This was logged in the audit trail.",
  noticeCancelled: "Order cancelled.",
  noticeShipped: "Shipment created.",
  noticeDelivered: "Shipment marked as delivered.",
  noticeRefunded: "Refund sent to the customer's original payment method through the payment provider.",
  noticeRefundedManual: "Refund recorded. No money was moved automatically — pay it back to the customer yourself.",
  noticeRefundPending: "Refund submitted and pending at the provider. Use “Check refund status” to confirm it.",
  noticeRefundCompleted: "Pending refund confirmed as completed.",
  noticeReturnApproved: "Return approved.",
  noticeReturnRejected: "Return rejected.",
  noticeReturnReceived: "Return marked as received.",
  noticeReturnClosed: "Return closed.",

  // Server action messages
  noteAdded: "Note added.",
  providerUnreachable: "Couldn't reach the payment provider — the connection is missing or disconnected. Check Settings → Payments.",
  providerReports: "Provider reports: {status}.",
  cancelReasonRequired: "Enter a reason for cancelling.",
  refundAmountRequired: "Enter a refund amount.",
  enterAmount: "Enter an amount",
  refundOfFailed: "Refund of {amount} failed: {error}. No money was moved.",
  refundFailedMsg: "Refund failed: {error}. No money was moved.",
  providerDeclined: "the provider declined it",
  stillPending: "Still pending at the provider.",
  returnNotInOrder: "This return doesn't belong to the order.",
  notesSaved: "Notes and tags saved.",
  unsubscribedSaved: "Unsubscribed from marketing.",

  // Shared labels
  order: "Order",
  orderNumber: "Order #{number}",
  customer: "Customer",
  payment: "Payment",
  fulfillment: "Fulfillment",
  reason: "Reason",
  reasonLabel: "Reason:",
  yourNote: "Your note:",
  instructionsLabel: "Instructions:",
  note: "Note",
  internalNote: "Internal note",
  ofQuantity: "of {count}",
  itemFallback: "Item",
  exportCsv: "Export CSV",
  exportCsvFiltered: "Export CSV (filtered)",
  subscribed: "Subscribed",
  notSubscribed: "Not subscribed",

  // Orders list
  ordersTitle: "Orders",
  ordersDescription: "Every order placed in your store, including unpaid ones awaiting payment.",
  searchPlaceholderPii: "Order #, email or name",
  searchPlaceholder: "Order #",
  anyStatus: "Any status",
  anyPayment: "Any payment",
  anyFulfillment: "Any fulfillment",
  from: "From",
  to: "To",
  sort: "Sort",
  sortNewest: "Newest",
  sortOldest: "Oldest",
  sortTotalDesc: "Total: high to low",
  sortTotalAsc: "Total: low to high",
  noOrdersMatch: "No orders match",
  noOrdersMatchHint: "Try different filters or dates.",
  resetFilters: "Reset filters",
  noOrdersYet: "No orders yet",
  noOrdersYetHint: "When customers check out, their orders appear here — including cash on delivery and bank transfer orders awaiting payment.",
  colMethod: "Method",
  itemCount: "{count} items",
  itemCount_one: "{count} item",

  // Order detail
  placedOn: "Placed {date}",
  cancelOrder: "Cancel order",
  cancelOrderTitle: "Cancel order #{number}?",
  cancelPaidOnline: "This order has been paid ({amount} not yet refunded). Cancelling {refundsFirst} through {provider}; the order is only cancelled if the refund succeeds.",
  cancelPaidOffline: "This order has been paid ({amount} not yet refunded). Cancelling {refundsFirst} (recorded as a manual refund — pay it back yourself); the order is only cancelled if the refund succeeds.",
  refundsFirst: "refunds the payment first",
  cancelNoRefundRole: "Your role can’t issue refunds, so you can’t cancel a paid order.",
  cancelUnpaid: "The order has no captured payment. Reserved stock is released and any discount use is given back. The customer is notified.",
  restockItems: "Restock items",
  restockOrderedHint: "Return the ordered quantities to inventory.",
  orderCancelledTitle: "Order cancelled",
  testOrderInfo: "This is a test-mode order. No real money was charged.",
  items: "Items",
  colProduct: "Product",
  colQty: "Qty",
  colUnit: "Unit",
  colDiscount: "Discount",
  colTax: "Tax",
  colFulfilled: "Fulfilled",
  sku: "SKU {sku}",
  digital: "Digital",
  restockedCount: "{count} restocked",
  notApplicable: "n/a",
  subtotal: "Subtotal",
  discount: "Discount",
  shipping: "Shipping",
  shippingWithMethod: "Shipping ({method})",
  taxLine: "{name} {rate}%",
  taxLineIncluded: "{name} {rate}% (included)",
  tax: "Tax",
  taxIncluded: "Tax (included)",
  paid: "Paid",
  refunded: "Refunded",
  refundable: "Refundable",
  customerNote: "Customer note",
  nothingToShip: "Nothing in this order needs shipping.",
  shipmentN: "Shipment {n}",
  shippedOn: "Shipped {date}",
  shippedOnBy: "Shipped {date} by {name}",
  deliveredOn: "delivered {date}",
  customerNotified: "customer notified",
  markDelivered: "Mark delivered",
  track: "Track",
  createShipment: "Create shipment",
  shipAfterPayment: "Ship this order once its payment is confirmed.",
  shipAfterPaymentOffline: "Ship this order once its payment is confirmed (mark the payment received first).",
  allFulfilled: "All items fulfilled.",
  noShipments: "No shipments yet.",
  refunds: "Refunds",
  refundsSummary: "{refunded} refunded of {paid} paid",
  via: "via {provider}",
  manualOffline: "manual (offline)",
  providerRef: "ref {ref}",
  restockedN: "restocked {count}",
  checkRefundStatus: "Check refund status",
  refundPendingAlert: "A refund is pending at the provider. Its amount is held back from the refundable total until it completes or fails.",
  nothingToRefund: "Nothing left to refund.",
  returns: "Returns",
  requestedOn: "Requested {date}",
  timeline: "Timeline",
  timelineHint: "Notes are internal and never shown to the customer.",
  addNotePlaceholder: "Add an internal note…",
  adding: "Adding…",
  addNote: "Add note",
  noEvents: "No events yet.",
  eventSystem: "system",
  eventInternalNote: "internal note",
  eventInternal: "internal",
  eventVisible: "visible to customer",
  noPaymentRecord: "No payment record.",
  captured: "Captured",
  paymentRef: "Payment ref",
  providerReference: "Provider reference",
  checkoutRef: "Checkout ref",
  lastUpdate: "Last update",
  refreshFromProvider: "Refresh status from provider",
  codInfo: "Cash on delivery: collect the payment, then record it here.",
  bankTransferInfo: "Bank transfer: mark paid once the funds arrive in your account.",
  markPaymentReceived: "Mark payment received",
  markPaymentReceivedTitle: "Mark payment received?",
  markAsPaid: "Mark as paid",
  markPaidBody: "Records {amount} as received for order #{number}. This is {audited} with your name and can’t be undone — if it’s a mistake you’ll need to record a refund.",
  audited: "audited",
  paidNoteHint: "e.g. transfer reference or who collected the cash.",
  paidOn: "Paid {date}",
  guestCheckout: "Guest checkout",
  customerOrdersSpent: "{count} orders · {amount} spent",
  customerOrdersSpent_one: "{count} order · {amount} spent",
  shippingAddress: "Shipping address",
  billingAddress: "Billing address",
  sameAsShipping: "Same as shipping",
  customerHidden: "Customer details hidden",
  customerHiddenHint: "Your role doesn't include access to customer information.",

  // Fulfillment panel
  itemsToShip: "Items to ship",
  alreadyShipped: "{count} already shipped",
  carrier: "Carrier",
  trackingNumber: "Tracking number",
  trackingUrl: "Tracking URL",
  trackingUrlHint: "Must start with https://",
  notifyShipping: "Email the customer a shipping confirmation",
  notifyShippingHint: "Includes tracking details when provided.",
  creatingShipment: "Creating shipment…",

  // Refund panel
  refundOnlineInfo: "The refund is sent through {provider} — the provider the customer paid with — back to their original payment method. It can take several business days to appear.",
  refundOfflineInfo: "This order was paid by {provider}. The refund is {recorded} here and updates the order totals, but no money moves automatically — pay the customer back yourself (cash, bank transfer…).",
  recorded: "recorded",
  refundAmount: "Refund amount",
  refundAmountHint: "Up to {amount} can be refunded.",
  refundReasonHint: "Kept on the order for your records.",
  restockHint: "Return these quantities to inventory when the refund succeeds. Leave at 0 if the items aren't coming back.",
  refunding: "Refunding…",
  refundVia: "Refund via {provider}",
  recordRefund: "Record refund",

  // Return actions
  approve: "Approve",
  approveReturn: "Approve return",
  approveBody: "The customer is told the return is approved and sees your instructions.",
  returnInstructions: "Return instructions",
  returnInstructionsHint: "e.g. where to send the items and what to include.",
  reject: "Reject",
  rejectReturn: "Reject return",
  rejectBody: "The customer will see your note.",
  noteToCustomer: "Note to customer",
  markReceived: "Mark received",
  markItemsReceived: "Mark items received",
  receiveBody: "Confirms the returned items arrived. You can refund afterwards.",
  refundReturn: "Refund return",
  refundThisReturn: "Refund this return",
  refund: "Refund",
  refundReturnOnline: "The refund goes back through the original payment provider to the customer's payment method.",
  refundReturnOffline: "Offline payment: the refund is recorded only — pay the customer back yourself.",
  suggestedHint: "Suggested: the returned items' share of their line totals.",
  restockReturned: "Restock the returned items",
  closeReturn: "Close return",
  closeBody: "Closes the request without further changes.",

  // Returns page
  returnsDescription: "Return requests submitted by customers from their order page. Approve, receive and refund them here or on the order.",
  noReturnsWithStatus: "No returns with status “{status}”",
  noReturnRequests: "No return requests",
  noReturnsHint: "When a customer asks to return items, the request shows up here.",
  suggestedRefund: "Suggested refund {suggested} · {refundable} refundable on the order",

  // Customers list
  customersTitle: "Customers",
  customersDescription: "People who ordered from your store or created an account. Created automatically at checkout.",
  segmentRepeat: "Repeat buyers",
  segmentSubscribers: "Email subscribers",
  segmentAccounts: "With accounts",
  segmentNoOrders: "No orders",
  customerSearchPlaceholder: "Name, email or phone",
  tag: "Tag",
  exactTag: "Exact tag",
  noCustomersMatch: "No customers match",
  noCustomersMatchHint: "Try another search, tag or segment.",
  showAll: "Show all",
  noCustomersYet: "No customers yet",
  noCustomersYetHint: "Customers appear here after their first order or when they create an account in your store.",
  colOrders: "Orders",
  colSpent: "Spent",
  colMarketing: "Marketing",
  colLastOrder: "Last order",

  // Customer detail
  account: "Account",
  guest: "Guest",
  customerSince: "Customer since {date}",
  totalSpent: "Total spent",
  avgOrder: "Avg. order",
  showing50: "Showing the 50 most recent.",
  refundedAmount: "−{amount} refunded",
  notesTags: "Notes & tags",
  notesTagsHint: "Internal — never shown to the customer.",
  tags: "Tags",
  tagsHint: "Press Enter or comma to add. Use tags to filter customers.",
  noTags: "No tags",
  noNote: "No note",
  contact: "Contact",
  hasStoreAccount: "Has a store account",
  guestNoPassword: "Guest (no password)",
  emailMarketing: "Email marketing",
  consentGiven: "Consent given",
  unsubscribed: "Unsubscribed",
  optInInfo: "Only customers can opt in, at checkout or in their account. You can unsubscribe them on request, but not subscribe them.",
  unsubscribeFromMarketing: "Unsubscribe from marketing",
  unsubscribeTitle: "Unsubscribe this customer?",
  unsubscribe: "Unsubscribe",
  unsubscribeBody: "They will stop receiving marketing emails. Order and shipping emails are not affected. Only the customer can opt back in.",
  addresses: "Addresses",
  noSavedAddresses: "No saved addresses.",
  defaultAddress: "Default",
};

export default en;
